import { EMPTY_SCAFFOLD_SELECTION, RowScaffold, ScaffoldSelection } from "../../interface";
import { buildRowRange } from "./buildRowRange";

/**
 * Replaces the current selection with a row range between two rows.
 *
 * @param rows - All available scaffold rows.
 * @param anchorRowId - The row ID of the selection anchor.
 * @param targetRowId - The row ID of the target row.
 * @returns A new selection state containing only the row range.
 */
export const setRowRangeSelection = <T>(
  rows: RowScaffold<T>[],
  anchorRowId: string,
  targetRowId: string,
): ScaffoldSelection => ({
  ...EMPTY_SCAFFOLD_SELECTION,
  selectedRows: buildRowRange(rows, anchorRowId, targetRowId),
});
